import { create } from 'zustand';
import { keywordTypeList, MenuList, RecipentList } from './components/filter/MessageHistoryFilterComponent';
import dayjs from 'dayjs';
import { IHistoryTableDataAuto } from './components/table/HistoryTable';
import { ICustomerInfo } from '../Manual/ManualStore';

export interface IRequestParams {
  // MenuList 의 code 값을 타입으로 처리
  tabType: typeof MenuList[number]['code']; // 메인메뉴 탭 타입
  // 탭 타입 - 테이블 컴포넌트에서 해당 부분이 바뀔 때 헤더 요소 변경처리
  recipentType?: typeof RecipentList[number]['code']; //
  startDate: string;
  endDate: string;
  keywordType: string;
  keyword: string;
}

export interface IHistoryFilterRequestParams {
  requestParams: IRequestParams;
  setRequestParams: (row: IRequestParams) => void;
}

export const useHistoryRequestParams = create<IHistoryFilterRequestParams>(set => ({
  requestParams: {
    tabType: 'AUTO_MESSAGE',
    recipentType: 'all',
    startDate: dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
    endDate: dayjs().format('YYYY-MM-DD'),
    keywordType: 'consigneeName',
    keyword: '',
  },
  setRequestParams: requestParams => set({ requestParams }),
}));

export interface ISingleHistoryMessage {
  singleHistoryMessage: IHistoryTableDataAuto | null;
  setSingleHistoryMessage: (row: IHistoryTableDataAuto | null) => void;
}
export const useSingleHistoryMessage = create<ISingleHistoryMessage>(set => ({
  singleHistoryMessage: null,
  setSingleHistoryMessage: singleHistoryMessage => set({ singleHistoryMessage }),
}));

// 수신인 넘기는 스토어..
export interface ITransferRecipent {
  transferRecipent: ICustomerInfo[] | null;
  setTransferRecipent: (row: ICustomerInfo[] | null) => void;
}
export const useTransferRecipent = create<ITransferRecipent>(set => ({
  transferRecipent: null,
  setTransferRecipent: transferRecipent => set({ transferRecipent }),
}));
